import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { GolfCourse } from '../golf-course';
import { HttpClient } from '@angular/common/http';
import { GolfCourseExpanded } from '../golf-course-expanded';

@Injectable({
  providedIn: 'root'
})
export class GolfCoursesService {

  constructor(private httpClient: HttpClient) {}

  getGolfCourses(): Observable<GolfCourse[]> {
      const url = 'https://golf-courses-api.herokuapp.com/courses';

      return this.httpClient.get<any>(url)
      .pipe(map(data => data.courses));
  }

  getCourse(id: number): Observable<GolfCourseExpanded> {
    const url = 'https://golf-courses-api.herokuapp.com/courses/' + id;

    return this.httpClient.get<any>(url)
    .pipe(map(data => data.data));
  }
}
